import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { SchoolRequestForm } from './SchoolRequestForm.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { LightBox } from './LightBox.js';
import Bloodhound from './external-adapters/typeaheadJqueryAdapter.js';
import '../../handlebars/templates/schoolSuggestion.tmpl.js';
import { Svg } from './Svg.js';
import { detectLocation } from './detectLocation.js';

class ZipCodeSearch extends PureComponent {
    constructor(props, context) {
        super(props, context);

        this.searchZipCode = this.searchZipCode.bind(this);
        this.handleSearchZipCode = this.handleSearchZipCode.bind(this);
    }

    componentDidMount() {
        if (!this.props.skipAutofocus) {
            this.focusZipCodeInput();
        }
    }

    focusZipCodeInput() {
        if (this.props.showZipCodeSearch) {
            $(ReactDOM.findDOMNode(this.refs.zipCodeInput)).focus();
        }
    }

    searchZipCode() {
        this.props.searchZipCode(ReactDOM.findDOMNode(this.refs.zipCodeInput).value, this.props.searchZipCodeDone);
    }

    handleSearchZipCode(event) {
        if (event.key === 'Enter') {
            this.searchZipCode();
        }
    }

    render() {
        if (!this.props.showZipCodeSearch) {
            return null;
        }

        return (
            <div>
                <div className="change-school-location">
                    <label>
                                    School zip code<br />
                        <span className="note">We use this to locate the correct school</span>
                    </label>
                    <div className="fluid-container">
                        <div className="col col8">
                            <input type="tel" ref="zipCodeInput" id="zipCodeInput" className="zip-code" maxLength="5"
                                autoFocus={!this.props.skipAutofocus} onKeyDown={this.handleSearchZipCode} pattern="\d*"/>
                        </div>
                        <div className="col col4">
                            <KeyboardClickable>
                                <a className="button-secondary small" role="button" tabIndex="0" onClick={this.searchZipCode}>Search</a>
                            </KeyboardClickable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
ZipCodeSearch.propTypes = {
    showZipCodeSearch: PropTypes.bool.isRequired,
    hideZipCodeSearch: PropTypes.func.isRequired,
    searchZipCode: PropTypes.func.isRequired,
    searchZipCodeDone: PropTypes.func,
    // TODO Consider updating this component and its callers such that the default behavior avoids this autofocus.
    //  That approach seems strongly preferable, but it'd be tricky to test because all existing callers expected this
    //  autofocus behavior.
    skipAutofocus: PropTypes.bool,
};

class SchoolSearchInput extends PureComponent {
    constructor(props, context) {
        super(props, context);

        this.state = { showSchoolSearchError: false, showMore: false, searchLimit: 5 };
    }

    componentDidMount() {
        this.setUpSchoolSuggest();
    }

    resetSearch() {
        $(ReactDOM.findDOMNode(this.schoolSearch)).typeahead('destroy');
        this.setUpSchoolSuggest();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location !== prevProps.location ||
            this.state.searchLimit !== prevState.searchLimit) {
            this.resetSearch();
        }
        // this is a hack, but React is turning autoComplete="new-password" into autocomplete="off" (off is no longer recognized by most browsers)
        $(ReactDOM.findDOMNode(this.schoolSearch)).attr('autocomplete', 'new-password');
    }

    componentWillUnmount() {
        $(ReactDOM.findDOMNode(this.schoolSearch)).typeahead('destroy');
    }

    setUpSchoolSuggest() {
        const props = this.props;
        const component = this;
        const limit = this.state.searchLimit;

        $(document).off('click', '.school-not-found').on('click', '.school-not-found', function (event) {
            event.preventDefault();
            if (document) {
                document.activeElement.blur();
            }
            component.props.showNewSchoolRequestForm();
        });

        $(document).off('click', '.show-more').on('click', '.show-more', function (event) {
            event.preventDefault();
            component.setState({ showMore: false, searchLimit: 25 });
        });

        $(ReactDOM.findDOMNode(this.schoolSearch)).typeahead({
            highlight: true,
            hint: true,
        }, {
            name: 'schools',
            display: function (item) { return item.schoolName + ' - ' + item.address1 + ', ' + item.cityName + ', ' + item.stateCode; },
            source: this.createSchoolSearchBloodhound(limit).ttAdapter(),
            limit,
            templates: {
                empty: '<div class="school-suggestion" style="font-style: italic;">No matches</div>',
                footer: function (c) {
                    return component.state.showMore
                        ? '<div class="school-suggestion show-more"><a href="#">Show more results</a><div>'
                        : '<div class="school-suggestion school-not-found"><a href="#">Don\'t see your school?</a><div>';
                },
                suggestion: Handlebars.templates['schoolSuggestion.tmpl'],
            },
        }).on('typeahead:selected', function (event, suggestion, dataName) {
            props.setSelectedSchool(suggestion.schoolId);
            props.getSchoolDetails(suggestion.schoolId);
            component.props.hideSchoolSearchNote();
        });
    }

    updateShowSearchError(value) {
        this.setState({
            showSchoolSearchError: value,
        });
    }

    createSchoolSearchBloodhound(limit) {
        const component = this;

        const remoteUrl = `/teachers/schoolSuggest.html?fieldsToSearch=PARTIAL_NAME&APIKey=${dcAPIKey}` +
            `&excludeTestRecords=${this.props.excludeTestRecords}` +
            `&max=${limit}` +
            '&keywords=';

        const schools = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('schoolSearch'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit,
            dupDetector: function (remote, local) {
                return remote.schoolId === local.schoolId;
            },
            remote: {
                url: remoteUrl,
                prepare: function (query, settings) {
                    return $.extend(settings, {
                        url: component.addLocation(settings.url + query),
                        error: function (jqxhr, textStatus, errorThrown) {
                            component.updateShowSearchError(true);
                        },
                        success: function (data, textStatus, jqxhr) {
                            const moreToSee = data && data.length && data[0].totalResults > 5 && component.state.searchLimit === 5;
                            if (moreToSee !== component.state.showMore) {
                                component.setState({ showMore: moreToSee });
                            }
                            component.updateShowSearchError(false);
                        },
                    });
                },
            },
        });

        schools.initialize();
        return schools;
    }

    addLocation(url) {
        if (this.props.location) {
            url += '&centerLat=' + this.props.location.latLng.lat + '&centerLng=' + this.props.location.latLng.lng;
        }
        return url;
    }

    render() {
        return (
            <div>
                {this.state.showSchoolSearchError &&
                    <div className="alert-message">
                        Something went wrong on our end and our engineering team is working on getting things back up and running.
                        Please try again in 5 minutes. Thanks!
                    </div>
                }
                <label>School name</label>
                <input ref={(r) => this.schoolSearch = r} type="text" id="school-suggest"
                    className="suggest-input school-suggest"
                    placeholder="Start typing..."
                    role="textbox"
                    aria-label="Search for a school"
                    onFocus={this.props.onSchoolSearchFocus}
                    onBlur={this.props.hideSchoolSearchNote}
                    autoComplete="new-password"
                />
            </div>
        );
    }
}
SchoolSearchInput.propTypes = {
    onSchoolSearchFocus: PropTypes.func.isRequired,
    hideSchoolSearchNote: PropTypes.func.isRequired,
    location: PropTypes.object,
    setSelectedSchool: PropTypes.func.isRequired,
    getSchoolDetails: PropTypes.func.isRequired,
    showNewSchoolRequestForm: PropTypes.func.isRequired,
    excludeTestRecords: PropTypes.bool,
};

SchoolSearchInput.defaultProps = {
    excludeTestRecords: true,
};

export const SchoolSearchBox = createReactClass({
    propTypes: {
        location: PropTypes.object,
        userFullName: PropTypes.string,
        userEmail: PropTypes.string,
        isTeacherRegistrationRequest: PropTypes.bool,
        showZipCodeSearch: PropTypes.bool,
        showSchoolSearchNote: PropTypes.bool,
        loadingSchoolDetails: PropTypes.bool,
        showNewSchoolRequestForm: PropTypes.bool,
        confirmedShowNewSchoolRequestForm: PropTypes.bool,
        getSchoolDetails: PropTypes.func.isRequired,
        setShowZipCodeSearch: PropTypes.func.isRequired,
        searchZipCode: PropTypes.func.isRequired,
        setShowSchoolSearchNote: PropTypes.func.isRequired,
        setShowNewSchoolRequestForm: PropTypes.func.isRequired,
        setConfirmedShowNewSchoolRequestForm: PropTypes.func.isRequired,
        setSelectedSchool: PropTypes.func.isRequired,
        onSchoolSearchFocus: PropTypes.func,
        excludeTestRecords: PropTypes.bool,
        skipAutofocus: PropTypes.bool,
        blockNewRequestForm: PropTypes.bool,
    },

    defaultProps: {
        excludeTestRecords: true,
    },

    getInitialState: function () {
        return {
            location: this.props.location,
        };
    },

    showZipCodeSearch() {
        this.props.setShowZipCodeSearch(true);
    },

    hideZipCodeSearch() {
        this.props.setShowZipCodeSearch(false);
    },

    onSchoolSearchFocus() {
        this.props.setShowSchoolSearchNote(true);

        if (this.props.onSchoolSearchFocus) {
            this.props.onSchoolSearchFocus();
        }
    },

    hideSchoolSearchNote() {
        this.props.setShowSchoolSearchNote(false);
    },

    showNewSchoolRequestForm() {
        this.props.setShowNewSchoolRequestForm(true);
    },

    hideNewSchoolRequestForm() {
        this.props.setShowNewSchoolRequestForm(false);
        this.props.setConfirmedShowNewSchoolRequestForm(false);
    },

    setConfirmShowNewSchoolRequestForm() {
        this.props.setConfirmedShowNewSchoolRequestForm(true);
    },

    renderInputLabel() {
        if (this.state.location) {
            return (

                <div className="enter-location-link">
                    <Svg icon="location" attributes={{ role: 'presentation' }}/>
                        Searching near {' '}
                    <KeyboardClickable>
                        {this.renderLocation()}
                    </KeyboardClickable>
                </div>
            );
        } else {
            return null;
        }
    },

    renderLocation() {
        if (this.props.loadingLocation) {
            return (
                <span className="search-city">Loading...</span>
            );
        } else {
            return (
                <span className="zip-location">
                    <b>{(this.props.location.cityName || this.props.location.zip) + ', ' + this.props.location.stateCode}</b> {' '}
                    <label className="change-location js-click-on-enter-or-space" tabIndex="0" onClick={this.showZipCodeSearch} htmlFor="zipCodeInput">Change location</label>
                </span>
            );
        }
    },

    detectLocationUsingMaxMind(event) {
        event.preventDefault();
        detectLocation(this.detectLocationUsingMaxMindCallback, false, true);
        // googlePlacesLoaded was loaded with the page, so we need to trigger this event again
        $(document).trigger('googlePlacesLoaded');
        this.hideNewSchoolRequestForm();
    },

    detectLocationUsingMaxMindCallback(location) {
        if (this.props.setLocation) {
            this.props.setLocation(location);
        }
        this.setState({
            location,
        });
        if (location) {
            this.hideZipCodeSearch();
        }
        scrollToPageTop(0);
    },

    renderNewSchoolRequestForm() {
        if (this.props.showNewSchoolRequestForm) {
            let lightboxContent;
            if (this.props.confirmedShowNewSchoolRequestForm) {
                lightboxContent = (
                    <SchoolRequestForm
                        isTeacherRegistrationRequest={this.props.isTeacherRegistrationRequest}
                        isNewRequest={true}
                        location={this.props.location}
                        userFullName={this.props.userFullName}
                        userEmail={this.props.userEmail}
                        exitHandler={this.hideNewSchoolRequestForm}
                    />
                );
            } else if (!this.props.location) {
                lightboxContent = (
                    <div className="form-redux update-school-info">
                        <h2>Don't see your school?</h2>
                        <div className={'zipcode-search-lightbox'}>
                            <p>Provide a zip code to help us find you.</p>

                            <ZipCodeSearch
                                showZipCodeSearch={true}
                                hideZipCodeSearch={this.hideZipCodeSearch}
                                searchZipCode={this.props.searchZipCode}
                                searchZipCodeDone={this.hideNewSchoolRequestForm}
                                skipAutofocus={this.props.skipAutofocus}
                            />

                        </div>
                        <p>OR</p>
                        <a href={'#'} onClick={this.detectLocationUsingMaxMind} className="button-secondary">Detect my current location</a>
                    </div>
                );
            } else {
                lightboxContent = (
                    <div className="form-redux update-school-info">
                        <h2>Don't see your school?</h2>
                        <p className="subheader">
                            We may already have your school listed using an alternate or abbreviated name. For example: "Abraham Lincoln Elementary" vs "Lincoln Elementary" or "PS 89" vs "P.S. 089"
                        </p>
                        <div className="eligibility-note">
                            <p>New school requests may only be submitted for DonorsChoose-eligible schools (U.S. public schools, public charter schools, or Head Start centers) that are not currently listed on DonorsChoose.</p>
                            <p><a href="https://help.donorschoose.org/hc/en-us/articles/202138393-School-Eligibility-Wizard" target="_blank">Review the full eligibility requirements</a> before you <a href="#" onClick={this.setConfirmShowNewSchoolRequestForm}>submit a request to add your school</a>.</p>
                        </div>
                    </div>
                );
            }
            return (
                <LightBox
                    content={lightboxContent}
                    lightboxCloseHandler={this.hideNewSchoolRequestForm}
                    tier={2}
                />
            );
        }
    },

    renderSchoolSearchNote() {
        if (this.props.showSchoolSearchNote) {
            return (
                <div>
                    <div className="alert-message school-search-tips desktop">
                        <p>Keep typing until you see your school, then click on it!</p>
                        <p><strong>Don't see your school?</strong> Try looking for different variations of your school's name, like "Tubman" instead of "Harriet Tubman Charter School".</p>
                        {!this.props.blockNewRequestForm && <p><strong><a onMouseDown={this.showNewSchoolRequestForm}>Still don't see your school?</a></strong></p> }
                    </div>
                </div>
            );
        }
    },

    render() {
        const showZipCodeSearch = this.props.showZipCodeSearch || !this.state.location;

        return (
            <div className="school-search-default">
                <div className="input-holder">
                    {this.renderInputLabel()}

                    <ZipCodeSearch
                        showZipCodeSearch={showZipCodeSearch}
                        hideZipCodeSearch={this.hideZipCodeSearch}
                        searchZipCode={this.props.searchZipCode}
                        skipAutofocus={this.props.skipAutofocus}
                    />

                    <SchoolSearchInput
                        onSchoolSearchFocus={this.onSchoolSearchFocus}
                        hideSchoolSearchNote={this.hideSchoolSearchNote}
                        setSelectedSchool={this.props.setSelectedSchool}
                        getSchoolDetails={this.props.getSchoolDetails}
                        location={this.props.location}
                        showNewSchoolRequestForm={this.showNewSchoolRequestForm}
                        excludeTestRecords={this.props.excludeTestRecords}
                    />
                </div>
                {this.renderSchoolSearchNote()}
                {this.renderNewSchoolRequestForm()}
            </div>
        );
    },
});
